import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid
} from '@material-ui/core';

import { updateSalesOrderProductStatus } from 'redux/actions';
import { Created, Admin, Received, Ready, Delivered } from 'constants/status';

const options = [Created, Admin, Received, Ready, Delivered];

const ProductStatusButton = (props) => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setSelectedIndex(options.findIndex(option => option === props.soProduct.status));

  }, [props.soProduct.status]);

  const handleButtonClick = () => {
    if(selectedIndex < 4 && props.isStandard) {
      setSelectedIndex(selectedIndex + 1);

      props.updateSalesOrderProductStatus({
        id: props.soProduct.id,
        status: options[selectedIndex + 1]
      }, props.user.adminId);

      if(options[selectedIndex + 1] === Ready) {
        props.checkProductStatusReady(props.soProduct.salesOrderId, props.soProduct.id);
      }
      if(options[selectedIndex + 1] === Delivered) {
        props.checkProductStatusDelivered(props.soProduct.salesOrderId, props.soProduct.id);
      }
    }
  };

  return (
    <Grid item xs={12}>
      <Button
        variant="contained"
        color="primary"
        aria-label="status button"
        onClick={() => handleButtonClick()}
      >
        {options[selectedIndex]}
      </Button>
    </Grid>
  )
};

export default connect (null, {updateSalesOrderProductStatus}) (ProductStatusButton);